import { LocationDto } from "app/data/management/models/location.dto";
import { DefinitionDto } from "@app/modules/shared/model/definition.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";

export class ShippingAddressDto extends DefinitionDto {
  public external_id?: string;
  public type?: string;
  public rec_status?: string;
  public current_account?: CurrentAccountDto;
  public country?: LocationDto;
  public region?: LocationDto;
  public state?: LocationDto;
  public city?: LocationDto;
  public county?: LocationDto;
  public address?: string;
  public phone?: string;
  public phone2?: string;
  public fax_num?: string;
}
